export default function Dummy() {
  return (
    <>
      <div
        style={{
          textAlign: "center",
          padding: "2rem 0",
        }}
      >
        <h1 style={{ fontSize: "3rem", marginBottom: "1.5rem" }}>
          502 Bad Gateway
        </h1>
        <p style={{ fontSize: "1.2rem" }}>
          The server was acting as a gateway or proxy and received an invalid
          response from the upstream server.
        </p>
        <hr style={{ border: "1px solid #ABABAB", margin: "2rem 0" }} />
        <p style={{ fontSize: "1.2rem" }}>nginx/1.10.2 (Ubuntu)</p>
      </div>
    </>
  );
}
